import Refresh from '@material-ui/icons/Refresh';
import ReactDOM from 'react-dom';

import NewOverlayIcon from '~/components/icons/NewOverlayIcon';
import NewTabIcon from '~/components/icons/NewTabIcon';
import Submission from '~/pages/forms/components/Submission';
import Overlay from '~/pages/forms/components/Submission/Overlay';

import FormToggles from '../FormToggles';
import styles from './Preview.style';

class Preview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submissionKey: Math.random(),
      previewingOverlay: false,
      height: 0,
    };
  }

  formRef = React.createRef();

  getPreviewURL() {
    const { form } = this.props;

    return `/forms/preview/${form.id}`;
  }

  previewOverlay = (event) => {
    event.preventDefault();

    const { form } = this.props;
    const wrapper = document.createElement('div');
    this.wrapper = wrapper;
    const height = this.formRef.current.offsetHeight;
    this.setState({ previewingOverlay: true, height });

    document.body.appendChild(wrapper);

    ReactDOM.render(
      <Overlay onClose={this.onCloseOverlay}>
        <Submission
          theme="default"
          form={form}
          params={{ disable_risk: true }}
        />
      </Overlay>,
      wrapper,
    );
  };

  onCloseOverlay = () => {
    this.setState({ previewingOverlay: false });
    this.wrapper.parentNode.removeChild(this.wrapper);
  };

  refresh = () => {
    this.setState({ submissionKey: Math.random() });
  };

  render() {
    const { submissionKey, previewingOverlay } = this.state;
    const { classes, form } = this.props;
    const placeholderHeight = this.state.height;

    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <FormToggles form={form} />

          <div className={classes.spacer} />

          <div onClick={this.refresh} className={classes.refresh}>
            Refresh
            <Refresh className={classes.icon} />
          </div>
        </div>

        <div
          className={classnames(classes.pane, {
            [classes.panePlaceholder]: previewingOverlay,
          })}>
          {previewingOverlay ? (
            <div
              className={classes.previewPlaceholder}
              style={{ height: placeholderHeight }}>
              Previewing form in overlay
            </div>
          ) : (
            <div className={classes.submission} ref={this.formRef}>
              <Submission
                theme="default"
                form={form}
                key={submissionKey}
                params={{ disable_risk: true }}
              />
            </div>
          )}
          <div className={classes.footer}>
            <div className={classes.previewTab}>
              <a
                className={classes.link}
                href={this.getPreviewURL()}
                rel="noopener noreferrer"
                target="_blank">
                Preview in new tab
                <NewTabIcon className={classes.icon} />
              </a>
            </div>

            <div className={classes.previewOverlay}>
              <a
                className={classes.link}
                href="#none"
                onClick={this.previewOverlay}>
                Preview in overlay
                <NewOverlayIcon className={classes.icon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Preview.propTypes = {
  form: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Preview);
